import './scss/index.scss'
import './scripts/toggleMenu'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
